var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Home',{attrs:{"user":_vm.user,"dashId":_vm.dashId,"entryType":_vm.entryType,"applicationContext":_vm.applicationContext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }